module.exports = __webpack_public_path__ + "img/xuxin.eb9106d0.png";